import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchAuthMe } from "../../../redux/slices/auth";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "./Chat.styled";
import { ChatListPane } from "./ChatListPane/ChatListPane";

export default function Chat() {
  const [userData, setUserData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const data = await dispatch(fetchAuthMe());
      setUserData(data.payload);
    };
    fetchData();
  }, [dispatch]);

  if (!userData) return null;

  return (
    <PagesWrapper>
      <styled.ChatContainer>
        <ChatListPane chats={userData.students} />
        <Outlet context={userData} />
      </styled.ChatContainer>
    </PagesWrapper>
  );
}
